import { ServiceState } from './index';
import { IStore } from '@store/index';
import { GetterTree } from 'vuex';

export default {

} as GetterTree<ServiceState, IStore>
